import {fetchWithTimeout, checkPermission, TIMEOUT, PERMISSION_ADMIN, PERMISSION_OPERATOR, PERMISSION_MONITORING} from './api_common';
import {getCookie, getFetchError, getCatchError} from '../app_common.js';

export const getApiSpectrum = async(pagePer, pageCur, siteName, market, category, min, max, sortTitle, sortOrder) => {
    if( !checkPermission('getApiSpectrum', PERMISSION_MONITORING) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeout(`/api/spectrum?per_page=${pagePer}&page=${pageCur}${siteName.length>0?'&site='+siteName:''}${market.length>0?'&market='+market:''}${category.length>0?'&category='+category:''}${max?'&min='+min:''}${max>0?'&max='+max:''}${sortTitle.length>0?'&sort_title='+sortTitle:''}${sortOrder.length>0?'&sort_order='+sortOrder:''}`, {
            timeout: TIMEOUT,
            method: 'GET',
            headers: {
                "accept": "application/json",
                "Authorization": "Bearer " + getCookie('accessToken')
            },
        });

        try {
            const json = await response.json();
            getFetchError(response, json, false);
            return json;
        } catch (e) {
            getFetchError(response, null, false);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}

export const getApiSpectrumCount = async(siteName, market) => {
    if( !checkPermission('getApiSpectrumCount', PERMISSION_MONITORING) )
    { 
        return null;
    }

    let marketQuery = '';
    if( siteName.length>0 && market.length>0 )
    {
        marketQuery = `${'&market='+market}`;
    }
    else if( siteName.length===0 && market.length>0 )
    {
        marketQuery = `${'?market='+market}`;
    }

    try {
        const response = await fetchWithTimeout(`/api/spectrum-count${siteName.length>0?'?site='+siteName:''}${marketQuery}`, {
            timeout: TIMEOUT,
            method: 'GET',
            headers: {
                "accept": "application/json",
                "Authorization": "Bearer " + getCookie('accessToken')
            }
        });

        try {
            const json = await response.json();
            getFetchError(response, json, false);
            return json;
        } catch (e) {
            getFetchError(response, null, false);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}

export const getApiSpectrumRank = async() => {
    if( !checkPermission('getApiSpectrumRank', PERMISSION_MONITORING) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeout(`/api/spectrum-rank`, {
            timeout: TIMEOUT,
            method: 'GET',
            headers: {
                "accept": "application/json",
                "Authorization": "Bearer " + getCookie('accessToken')
            },
        });

        try {
            const json = await response.json();
            getFetchError(response, json, false);
            return json;
        } catch (e) {
            getFetchError(response, null, false);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}